import { render } from "./ExaminationForm.vue?vue&type=template&id=17b55ddf&scoped=true"
import script from "./ExaminationForm.vue?vue&type=script&lang=js"
export * from "./ExaminationForm.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ExaminationForm.vue?vue&type=style&index=1&id=17b55ddf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b55ddf"]])

export default __exports__